module.exports = __webpack_public_path__ + "media/images/pragmaprime-60f48888796795ee86c62cdf07a0a897.png";